var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-actions" },
    [
      _c(
        "v-layout",
        { staticClass: "action-options-wrapper" },
        [
          _vm.canAddPlaceInput && _vm.isEnabled("addPlaceInput")
            ? _c(
                "v-flex",
                { class: { "high-resolution": _vm.$highResolution } },
                [
                  _c("map-form-btn", {
                    staticClass: "add-place-btn",
                    attrs: {
                      icon: "add_location",
                      title: _vm.$t("formActions.addPlaceInput")
                    },
                    on: { clicked: _vm.addPlaceInput }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.mode === _vm.constants.modes.directions &&
          _vm.isEnabled("clearPlaces")
            ? _c(
                "v-flex",
                { class: { "high-resolution": _vm.$highResolution } },
                [
                  _c("map-form-btn", {
                    staticClass: "clear-route-btn",
                    attrs: {
                      icon: "clear_all",
                      title: _vm.$t("formActions.clearRoute")
                    },
                    on: { clicked: _vm.clearPlaces }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.mode === _vm.constants.modes.directions &&
          _vm.isEnabled("reverseRoute")
            ? _c(
                "v-flex",
                { class: { "high-resolution": _vm.$highResolution } },
                [
                  _c("map-form-btn", {
                    staticClass: "reverse-route-btn",
                    attrs: {
                      icon: "repeat",
                      title: _vm.$t("formActions.reverseRoute")
                    },
                    on: { clicked: _vm.reverseRoute }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEnabled("roundtrip")
            ? _c(
                "v-flex",
                { class: { "high-resolution": _vm.$highResolution } },
                [
                  _c("map-form-btn", {
                    staticClass: "round-trip-btn",
                    attrs: {
                      text: _vm.$t("formActions.roundTrip"),
                      title: _vm.$t("formActions.toggleRoundTrip"),
                      icon: "settings_backup_restore",
                      color: _vm.roundTripActive ? "primary" : "default"
                    },
                    on: { clicked: _vm.toggleRoundTrip }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEnabled("routeImporter")
            ? _c(
                "v-flex",
                { class: { "high-resolution": _vm.$highResolution } },
                [
                  _c("route-importer", {
                    staticClass: "route-importer",
                    on: { contentUploaded: _vm.contentUploaded }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-681f6662", { render: render, staticRenderFns: staticRenderFns })
  }
}